// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"4065":"7f678278b2d29df47171","4254":"96661b9f421b07ce7189"}[chunkId] + "";
};